import React, { useEffect, useState } from 'react';
import { service } from 'services';
import { appendRemoteScript } from 'utils';

export default () => {
  const [loaded, toggleLoaded] = useState(false);
  const [token, setToken] = useState('');
  const [products, setProducts] = useState([]);

  useEffect(() => {
    service.adServer.getTokenAndProducts().then((res) => {
      setToken(res?.token || '');
      setProducts(res?.usage || []);
    });

    appendRemoteScript({
      url: 'https://frontend-services.ionos.com/t/tag/IONOS_CLOUD/dcd_mobile.js', // https://frontend-services.ionos.com/t/tag/IONOS_CLOUD/dcd.js
      id: 'oaotag',
    }).then(() => toggleLoaded(true));
  }, []);

  useEffect(() => {
    if (loaded && !!token) {
      const { OAO } = window;
      if (OAO) {
        OAO.q.c.push(['setFrontendToken', token]);
        OAO.q.c.push(['setPageName', 'DCD Mobile']);
        OAO.q.c.push(['setLanguage', 'de_DE']);

        products.forEach((product) => {
          const { typeCategory = '', amount = 0 } = product;
          OAO.q.ias.push(['addVisitorData', typeCategory, amount]);
          // OAO.q.ias.push(['addVisitorData', 'ramUsage', 1024]);
        });

        // OAO.q.ias.push(['refresh']);
        OAO.q.ias.push(['refreshSubset', '.ias-zone']);

        // Example from the provided website: https://developers.ionos.com/frontend-services/adserver/technical
        // OAO.q.ias.push(['addVisitorData', 'name', 'John Doe']);
        // OAO.q.ias.push(['addVisitorData', 'hasRankingcoach', 'true']);
        // OAO.q.ias.push(['addVisitorData', 'isPartner', 'false']);
        // OAO.q.ias.push(['addVisitorData', 'hasPartnerInterests', 'false']);
        // OAO.q.ias.push(['addVisitorData', 'abuseDetected', 'false']);
        // OAO.q.ias.push(['addVisitorData', 'abuseFile', '/a/folder/on/my/webspace/index.php']);
        // OAO.q.ias.push(['refreshSubset', '.ias-zone']);
      }
    }
    // <div class="ias-zone ias-survey-zone" data-ias-zoneid="ionos_cloud_layer"></div>
    // eslint-disable-next-line
  }, [loaded, products, token]);

  return (
    <div className="screen-ad-server" style={{ overflow: 'scroll' }}>
      <div className="ias-zone" data-ias-zoneid="dcd_card_first" />
    </div>
  );
};
